import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Content } from '@23degrees/shared-code/models';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FavoritesService {
  private http = inject(HttpClient);

  API_PATH = '/services/pub/api/v1/favorite';

  myFavorites(page: number, itemsCount: number = 10, type?: string[]): Observable<any> {
    return this.http.post(`${this.API_PATH}/myFavorites/${page}/${itemsCount}`, {
      sortOrder: {
        field: 'created_at',
        order: -1,
      },
      types: type,
    });
  }

  myFavoritesPromise(page: number, itemsCount: number = 10, type?: string[]): Promise<any> {
    return this.http
      .post(`${this.API_PATH}/myFavorites/${page}/${itemsCount}`, {
        sortOrder: {
          field: 'created_at',
          order: -1,
        },
        types: type,
      })
      .toPromise();
  }

  addFavorite(content: Content): Observable<any> {
    return this.http.post(`${this.API_PATH}/addFavorite`, { contentItemId: content._id });
  }

  addFavoritePromise(id: string): Promise<any> {
    return this.http.post(`${this.API_PATH}/addFavorite`, { contentItemId: id }).toPromise();
  }

  removeFavorite(id: string): Observable<any> {
    return this.http.post(`${this.API_PATH}/removeFavorite`, { contentItemId: id });
  }

  removeFavoritePromise(contentId: string): Promise<any> {
    return this.http.post(`${this.API_PATH}/removeFavorite`, { contentItemId: contentId }).toPromise();
  }

  isFavorite(content: Content): Observable<any> {
    return this.http.get(`${this.API_PATH}/isFavorite/${content._id}`);
  }

  isFavoritePromise(id: string): Promise<any> {
    return this.http.get(`${this.API_PATH}/isFavorite/${id}`).toPromise();
  }
}
